import { z } from 'zod';
import { Period } from '../../types';

export const amount = z.object({
  amount: z.number(),
  period: z.nativeEnum(Period),
});

export const optionalAmount = z.object({
  amount: z.number().optional(),
  period: z.nativeEnum(Period).optional(),
});

export const amountApplicable = amount
  .partial()
  .and(
    z.object({
      isNotApplicable: z.boolean().optional(),
    }),
  )
  .transform(data => {
    if (data.isNotApplicable) {
      return { ...data, amount: 0 };
    }
    return data;
  });
